var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHelpMenuIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.33334 13.7501C7.33334 12.7376 6.51253 11.9167 5.50001 11.9167C4.48748 11.9167 3.66667 12.7376 3.66667 13.7501V15.5834C3.66667 16.5959 4.48748 17.4167 5.50001 17.4167C6.51253 17.4167 7.33334 16.5959 7.33334 15.5834V13.7501Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3333 13.7501C18.3333 12.7376 17.5125 11.9167 16.5 11.9167C15.4875 11.9167 14.6667 12.7376 14.6667 13.7501V15.5834C14.6667 16.5959 15.4875 17.4167 16.5 17.4167C17.5125 17.4167 18.3333 16.5959 18.3333 15.5834V13.7501Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.66667 13.7501V11.0001C3.66667 9.05516 4.43929 7.1899 5.81456 5.81463C7.18982 4.43937 9.05508 3.66675 11 3.66675C12.9449 3.66675 14.8102 4.43937 16.1855 5.81463C17.5607 7.1899 18.3333 9.05516 18.3333 11.0001V13.7501M16.5 17.4167C16.5 18.1461 15.9205 18.8456 14.8891 19.3613C13.8576 19.877 12.4587 20.1667 11 20.1667",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpMenuIcon);
export default __webpack_public_path__ + "static/media/help-menu-icon.8905c9b0ec2614651972b0453f4575f5.svg";
export { ForwardRef as ReactComponent };